import React, { useCallback } from 'react';
import { withTranslation } from '../../../ChildrenContext.js';
import PropTypes from 'prop-types';
import CustomTooltip from '../../../Tooltip';
import CSV from '../../../../utils/CSV/index';
import config from '../../../../config.js';

import { useTemplateConfig } from '../../../../context/TemplateConfigContext';


const csv = new CSV();

const StatisticsByDayCSV = ({ data, headerName, t }) => {
    const { assets } = useTemplateConfig();
    const getData = useCallback(() => {
        let dataCopy = [...(data || [])];
        dataCopy.unshift(headerName || []);
        return dataCopy;
    }, [data, headerName]);

    const onDownload = useCallback(() => {
        let dataToDownload = csv.convert(getData());
        csv.download(dataToDownload, config.reportByDayFileNameCSV);
    }, [getData]);

    const staticNames = t?.reportPage || {};

    return (
        <CustomTooltip id={`statistics-csv`} tooltip={staticNames.downloadCSV}>
            <a
                className="btn"
                id="statisticReport"
                onClick={onDownload}
            >
                <img src={assets.icons.downArrow} alt=""/>
            </a>
        </CustomTooltip>
    );
};

StatisticsByDayCSV.propTypes = {
    data: PropTypes.array,
    headerName: PropTypes.array,
    t: PropTypes.object
};

StatisticsByDayCSV.defaultProps = {
    data: [],
    headerName: [],
    t: {}
};

export default withTranslation(StatisticsByDayCSV);